var docEl = document.documentElement
var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
var remSize = 100
var recalc = function () {
  var clientWidth = docEl.clientWidth
  if (!clientWidth) {
    return
  }
  if (clientWidth <= 720) {
    docEl.style.fontSize = remSize * (clientWidth / 500) + 'px'
  } else {
    docEl.style.fontSize = remSize + 'px'
  }
}

if (document.addEventListener) {
  window.addEventListener(resizeEvt, recalc, false)
  document.addEventListener('DOMContentLoaded', recalc, false)
}



// WEBPACK FOOTER //
// ./src/common/script/getRem.js